import dhtmlx from "dhtmlxAdapter";
import i18n from "l10n";
import XRegExp from "xregexp";
import BaseOuterView from 'views/base.outer.view.js';

let keepMeSignedIn = false;

const LoginView = BaseOuterView.extend({
    template: require('handlebars').compile(require('templates/login.hbs')),
    el: '#page-main-content',
    events: {
        "click [data-navigation]": "notifyNavigator",
        "click #login-button": "login",
        "keydown .input-control": "keypress",
        "click #google": "googleAuth",
        "click #yahoo": "yahooAuth",
        "click #microsoft": "microsoftAuth",
        "click #facebook": "facebookAuth",
        "click #recover-button": "recoverPass",
        'click #keepsigned-checkbox [type="checkbox"]': 'keepSignedClick',
        'change #terms-and-conditions-checkbox': 'toggleTermsCheckbox',
        'click #toggle2FA': 'show2FAField',
        'click .togglePasswordType': 'togglePassWordViewable'
    },
    initialize: function (options) {
        this.rx = XRegExp('\\p{L}'); //Require.js does not pass this on older browsers
        if ($("#terms-and-conditions").is(':visible')) {
            this.checkedTerms = false;
        } else {
            this.checkedTerms = true;
            var $terms = $('#terms-and-conditions-checkbox');
            $terms.prop('checked', 'true');
            this.toggleTermsCheckbox({currentTarget: $terms});
        }
        this.bootstrap(options).finally(this.render.bind(this));

        console.info('Initializing Login View');
        var browser = $.get_browser();
        if (!(browser.name === "Firefox" || browser.name === "Chrome")) {
            dhtmlx.alert(i18n.t("voucher.betterbrowserview"));
        }
    },
    render() {
        this.$el.html(this.template({fbApi:!!this.fbApi}));
    },
    show2FAField: function () {
        if ($('.secret:visible').length !== 0) {
            $('.secret').hide();
        } else {
            $('.secret').show();
        }
    },
    login: async function (event) {
        if (this.isPostpaid && !this.checkedTerms) {
            return;
        }
        event.preventDefault(); // Don't let this button submit the form
        $('.alert-error').hide(); // Hide any errors on a new submit
        var url = '/CampaignCloud/login';
        console.info('Logging in...');
        var TOTPKey;
        if ($('.secret:visible').length !== 0) {
            TOTPKey = $('#secretInput').val();
        }
        const $usernameInput = $('#usernameInput');
        const $passwordInput = $('#passwordInput');
        var formValues = {
            username: $usernameInput.val(),
            password: $passwordInput.val(),
            'remember-me': keepMeSignedIn,
            TOTPKey: TOTPKey
        };
        $usernameInput.prop("disabled", true);
        $passwordInput.prop("disabled", true);
        $('#login-button').prop("disabled", true);
        await this.initiateAndHandleLogin(url, formValues);
    },
    keypress: function (e) {
        var which = e.which;
        if (which === 13) {
            $('#login-button').click();
            return false;
        }
        var key = e.key;
        if (key) {
            var isAlpha = this.rx.test(key);
            if (!isAlpha) {
                return;
            }
            var isUp = key.toUpperCase() === key; // uppercase
            var isLow = key.toLowerCase() === key; // lowercase
            // event.shiftKey does not seem to be normalized by jQuery(?) for IE8-
            var isShift = ( e.shiftKey ) ? e.shiftKey : ( which === 16 ); // shift is pressed

            // uppercase w/out shift or lowercase with shift == caps lock
            if ((isUp && !isShift) || (isLow && isShift)) {
                $('#capsonalert').show();
            } else {
                $('#capsonalert').hide();
            }
        }
    },
    googleAuth: function () {
        this.commonOAuthCallback(0);
    },
    commonOAuthCallback: async function (provider) {
        var url = '/CampaignCloud/oauthClient/startAuthentication';
        var formValues = {
            provider: provider,
            state: 'login'
        };
        console.info(formValues);
        try {
            const response = await $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                dataType: "json",
                data: formValues,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            });
            if (response.status === 'success') {
                console.info(response.LocationUri);
                window.open(response.LocationUri, '_self');
            } else if (response.status === 'fail') {
                dhtmlx.alert(i18n.t("login.registrationerror"));
            }
        } catch (e) {
            console.info(e);
        }
    },
    yahooAuth: function () {
        this.commonOAuthCallback(1);
    },
    microsoftAuth: function () {
        this.commonOAuthCallback(2);
    },
    recoverPass: function () {
        window.open('Login.htm#PasswordRecover', '_self');
    },
    keepSignedClick: function () {
        if ($('#keep-signed').prop('checked')) {
            keepMeSignedIn = true;
            console.log("keep signed");
        } else {
            keepMeSignedIn = false;
            console.log("not checked");
        }
    },
    toggleTermsCheckbox: function (e) {
        var checked = $(e.currentTarget).prop("checked");
        this.checkedTerms = checked;
        if (checked) {
            localStorage.acceptedTC = true;
        }
        var $login = $("#login-button");
        $login.prop("disabled", !checked);

        if (!checked) {
            $login.css({"background-color": "gray", "cursor": "not-allowed"});
            $("#terms-and-conditions").addClass("required-input");
        }
        else {
            $login.css({"background-color": "", "cursor": "pointer"});
            $("#terms-and-conditions").removeClass("required-input");
        }
    },
    togglePassWordViewable: function (e) {
        var $currentTarget = $(e.currentTarget);
        var $passInput = $("#" + $currentTarget.data("id"));
        if ($passInput.attr("type") === "password") {
            $passInput.attr("type", "text");
            $($currentTarget.find("span")).text(i18n.t("hide"));
        } else {
            $passInput.attr("type", "password");
            $($currentTarget.find("span")).text(i18n.t("show"));
        }
        e.preventDefault();
    }
});

export {LoginView as default};